import { getNamedDates } from 'services/utils';

/**
 * Ciclos que as páginas de fechamento (Destaques, Galeria de selos e Extrato de Premiação) oferecem:
 * do 1S2023 ao ciclo mais recente já fechado. As três precisam oferecer os MESMOS ciclos, por isso o
 * intervalo fica aqui e é conferido por `pages/__tests__/cycle-ceilings.spec.ts`.
 */
export function ciclosDeFechamento<T extends { date_start: number }>(ciclos?: T[]): T[] {
  const { ciclo_1S2023: primeiro, ciclo_1S2026: ultimo } = getNamedDates();

  return (ciclos ?? []).filter(item => item.date_start >= primeiro && item.date_start <= ultimo);
}
